import {useState, useEffect} from 'react'
import {
    useUsid,
    useShopperContext,
    useShopperContextsMutation,
} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useLocaleCountry} from './use-locale-custom'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMulticountryUtils from '../custom-hooks/use-multicountry-utils'

const useCorporateBanner = () => {
    const [showCorporateBanner, setShowCorporateBanner] = useState(false)
    const {site} = useMultiSite()
    const {usid} = useUsid()
    const currentCountry = useLocaleCountry()
    const {customParams} = getConfig()
    const {buildLocalizedUrl} = useMulticountryUtils()
    const updateShopperContext = useShopperContextsMutation('updateShopperContext')

    const redirectMain = `https://${customParams.currentHost}${buildLocalizedUrl('/')}`

    const {data: shopperContext} = useShopperContext(
        {parameters: {usid, siteId: site.id}},
        {enabled: true},
    )

    // Ensure sourceCode is handled appropriately without direct assignment
    useEffect(() => {
        // Check if sourceCode exists in the shopper context
        const hasSourceCode = Boolean(shopperContext?.sourceCode)
        setShowCorporateBanner(hasSourceCode)

        if (/corporate/.test(window.location?.host)) {
            setShowCorporateBanner(true)
        }
    }, [shopperContext])

    const exitSource = async () => {
        try {
            // Remove cluid from localStorage
            localStorage.removeItem('cluid')

            // Update shopper context to remove source code
            const newShopperContext = {
                customQualifiers: {
                    countryCode: currentCountry,
                    isCorporate: false,
                },
                sourceCode: '',
            }

            const payload = {
                parameters: {usid, siteId: site.id},
                body: newShopperContext,
            }

            // Wait for the context update to complete
            await updateShopperContext.mutateAsync(payload)

            // Only update UI state after successful context update
            setShowCorporateBanner(false)
        } catch (error) {
            console.error('Failed to update shopper context:', error)
        }

        window.location.href = redirectMain
    }

    return {
        showCorporateBanner,
        exitSource,
    }
}

export default useCorporateBanner
